import React from "react";
import styled from "styled-components";
import { Modal, Button } from "components";

export const SpaceAfterSlashWarningModal = ({
  open,
  message = "Space after '/' is not allowed.",
  onClose,
}) => {
  return (
    <Modal open={open} onClose={onClose} size="medium" title={"Approve Offer/Incentive"}>
      <MessageStyle>
        <WarningText>WARNING:</WarningText> {message}
      </MessageStyle>
      <div className="d-flex mt-4">
        <Button
          size="small"
          buttonTheme="primary"
          width="fit-content"
          className="ml-auto"
          type="button"
          onClick={onClose}
        >
          OK
        </Button>
      </div>
    </Modal>
  );
};

const MessageStyle = styled.div`
  font-size: 14px;
  padding: 10px;
`;

const WarningText = styled.span`
  color: ${(props) => props.theme.palette.warning};
`;